document.addEventListener('DOMContentLoaded', function () {
  function rafThrottle(callback) {
    var ticking = false;

    return function () {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        callback();
      });
    };
  }

  function initBlogFilters() {
    var root = document.querySelector('[data-cheddr-blog-index]');
    if (!root) {
      return;
    }

    if (root.getAttribute('data-cheddr-blog-disable-filters') === 'true') {
      return;
    }

    var pillsWrap = root.querySelector('.cheddr-blog-filter-pills-wrap');
    var grid = root.querySelector('.cheddr-blog-grid');
    if (!pillsWrap && grid) {
      pillsWrap = document.createElement('div');
      pillsWrap.className = 'cheddr-blog-filter-pills-wrap';
      pillsWrap.innerHTML =
        '<p class="cheddr-blog-label">Filter by topic</p>' +
        '<div class="cheddr-blog-filter-pills" role="toolbar" aria-label="Blog topics">' +
        '<a href="' +
        window.location.pathname +
        '" class="cheddr-blog-filter-pill" data-cheddr-blog-pill data-tag-handle="all" aria-pressed="true">All</a>' +
        '</div>';
      grid.parentNode.insertBefore(pillsWrap, grid);
    }

    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-cheddr-blog-pill]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cheddr-blog-card]'));
    var currentTag = root.getAttribute('data-current-tag') || 'all';

    if (!pills.length || !cards.length) {
      return;
    }

    function applyFilter(tagHandle) {
      pills.forEach(function (pill) {
        var isActive = pill.getAttribute('data-tag-handle') === tagHandle;
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      cards.forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(/\s+/).filter(Boolean);
        var matches = tagHandle === 'all' || tags.indexOf(tagHandle) !== -1;
        card.hidden = !matches;
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function (event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
          return;
        }

        event.preventDefault();
        currentTag = pill.getAttribute('data-tag-handle') || 'all';
        applyFilter(currentTag);
      });
    });

    applyFilter(currentTag);
  }

  function initReadingProgress(root) {
    var progressBar = root.querySelector('[data-cheddr-blog-progress]');
    if (!progressBar) {
      return;
    }

    var updateProgress = rafThrottle(function () {
      var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      var progress = maxScroll > 0 ? Math.min(Math.max(window.scrollY / maxScroll, 0), 1) : 0;
      progressBar.style.width = String(progress * 100) + '%';
    });

    updateProgress();
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
  }

  function slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace(/-{2,}/g, '-');
  }

  function initToc(root) {
    var toc = root.querySelector('#cheddr-blog-toc');
    var tocBody = root.querySelector('[data-cheddr-blog-toc-body]');
    var tocToggle = root.querySelector('[data-cheddr-blog-toc-toggle]');
    var articleBody = root.querySelector('[data-cheddr-article-body]');

    if (!toc || !tocBody || !tocToggle || !articleBody) {
      return;
    }

    var headings = Array.prototype.slice.call(articleBody.querySelectorAll('h2, h3'));
    var topLevelTag = 'h2';
    if (headings.length < 3) {
      headings = Array.prototype.slice.call(articleBody.querySelectorAll('h4.wp-block-heading, h4'));
      topLevelTag = 'h4';
    }
    if (headings.length < 3) {
      toc.hidden = true;
      return;
    }

    var usedIds = {};
    headings.forEach(function (heading) {
      var headingId = heading.id ? heading.id.trim() : '';
      if (!headingId) {
        headingId = slugify(heading.textContent || 'section');
      }
      if (!headingId) {
        headingId = 'section';
      }
      if (usedIds[headingId]) {
        usedIds[headingId] += 1;
        headingId = headingId + '-' + usedIds[headingId];
      } else {
        usedIds[headingId] = 1;
      }
      heading.id = headingId;
    });

    var list = document.createElement('ul');
    var currentTopItem = null;
    var currentSubList = null;
    var linkMap = {};

    headings.forEach(function (heading) {
      var item = document.createElement('li');
      var link = document.createElement('a');
      link.className = 'cheddr-blog-toc__link';
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      link.setAttribute('data-heading-id', heading.id);
      item.appendChild(link);
      linkMap[heading.id] = link;

      link.addEventListener('click', function (event) {
        event.preventDefault();
        var target = document.getElementById(heading.id);
        if (!target) {
          return;
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      if (heading.tagName.toLowerCase() === topLevelTag) {
        list.appendChild(item);
        currentTopItem = item;
        currentSubList = null;
      } else if (currentTopItem) {
        if (!currentSubList) {
          currentSubList = document.createElement('ul');
          currentSubList.className = 'cheddr-blog-toc__sublist';
          currentTopItem.appendChild(currentSubList);
        }
        currentSubList.appendChild(item);
      } else {
        list.appendChild(item);
      }
    });

    tocBody.innerHTML = '';
    tocBody.appendChild(list);
    toc.hidden = false;

    function syncTocState() {
      if (window.innerWidth <= 768) {
        toc.classList.remove('is-open');
        tocToggle.setAttribute('aria-expanded', 'false');
      } else {
        toc.classList.add('is-open');
        tocToggle.setAttribute('aria-expanded', 'true');
      }
    }

    toc.classList.add('is-open');
    syncTocState();

    tocToggle.addEventListener('click', function () {
      if (window.innerWidth > 768) {
        return;
      }
      toc.classList.toggle('is-open');
      tocToggle.setAttribute('aria-expanded', toc.classList.contains('is-open') ? 'true' : 'false');
    });

    var resizeHandler = rafThrottle(syncTocState);
    window.addEventListener('resize', resizeHandler);

    var visibleHeadings = new Set();

    function setActiveHeading() {
      var activeId = null;

      headings.forEach(function (heading) {
        var top = heading.getBoundingClientRect().top;
        if (top <= 160) {
          activeId = heading.id;
        }
      });

      if (!activeId && visibleHeadings.size) {
        headings.some(function (heading) {
          if (visibleHeadings.has(heading.id)) {
            activeId = heading.id;
            return true;
          }
          return false;
        });
      }

      Object.keys(linkMap).forEach(function (headingId) {
        linkMap[headingId].classList.toggle('cheddr-blog-toc-active', headingId === activeId);
      });
    }

    var setActiveHeadingRaf = rafThrottle(setActiveHeading);

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          visibleHeadings.add(entry.target.id);
        } else {
          visibleHeadings.delete(entry.target.id);
        }
      });
      setActiveHeadingRaf();
    }, {
      rootMargin: '-20% 0px -60% 0px',
      threshold: [0, 1]
    });

    headings.forEach(function (heading) {
      observer.observe(heading);
    });

    window.addEventListener('scroll', setActiveHeadingRaf, { passive: true });
    setActiveHeading();
  }

  function cleanArticleBody(root) {
    var article = root.querySelector('[data-cheddr-article-body] article');
    if (!article) {
      return;
    }

    Array.prototype.slice.call(article.querySelectorAll('p')).forEach(function (paragraph) {
      var hasMeaningfulChildren = paragraph.querySelector('img, iframe, video, table, ul, ol, blockquote, a, strong, em');
      if (!hasMeaningfulChildren && !paragraph.textContent.replace(/\u00a0/g, ' ').trim()) {
        paragraph.remove();
      }
    });
  }

  function initFaqSchema(root) {
    var articleBody = root.querySelector('[data-cheddr-article-body] article');
    if (!articleBody || document.getElementById('cheddr-blog-faq-schema')) {
      return;
    }

    var nodes = Array.prototype.slice.call(articleBody.querySelectorAll('h2, h3, p, ul, ol'));
    var faqHeadingIndex = nodes.findIndex(function (node) {
      return /^faq|^frequently asked questions?/i.test((node.textContent || '').trim());
    });

    if (faqHeadingIndex === -1) {
      return;
    }

    var faqItems = [];
    var currentQuestion = null;

    for (var i = faqHeadingIndex + 1; i < nodes.length; i += 1) {
      var node = nodes[i];
      var tagName = node.tagName.toLowerCase();
      if (tagName === 'h2') {
        break;
      }
      if (tagName === 'h3') {
        if (currentQuestion && currentQuestion.acceptedAnswer.text.trim()) {
          faqItems.push(currentQuestion);
        }
        currentQuestion = {
          '@type': 'Question',
          name: node.textContent.trim(),
          acceptedAnswer: {
            '@type': 'Answer',
            text: ''
          }
        };
        continue;
      }
      if (currentQuestion) {
        var text = node.textContent.trim();
        if (text) {
          currentQuestion.acceptedAnswer.text += (currentQuestion.acceptedAnswer.text ? ' ' : '') + text;
        }
      }
    }

    if (currentQuestion && currentQuestion.acceptedAnswer.text.trim()) {
      faqItems.push(currentQuestion);
    }

    if (!faqItems.length) {
      return;
    }

    var schemaNode = document.createElement('script');
    schemaNode.type = 'application/ld+json';
    schemaNode.id = 'cheddr-blog-faq-schema';
    schemaNode.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems
    });
    document.head.appendChild(schemaNode);
  }

  function initArticleEnhancements() {
    var root = document.querySelector('[data-cheddr-blog-article]');
    if (!root) {
      return;
    }

    cleanArticleBody(root);
    initReadingProgress(root);
    initToc(root);
    initFaqSchema(root);
  }

  initBlogFilters();
  initArticleEnhancements();
});
